<template>
  <div class="lb">
    <div ref="barMian" class="barMian" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: 'template.scope48',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      title: '基本水平条形图-有问题-scope48',
      timer: null,
      defaultdata: [
        { value1: "1月", value2: "80", value3: "系列一", value4: '元' },
        { value1: "2月", value2: "40" },
        { value1: "3月", value2: "62" },
        { value1: "4月", value2: "90" },
        { value1: "5月", value2: "62" },
      ],
      valueMap: [
        { name: '名称', key: "value1" },
        { name: '数值', key: "value2" },
        { name: '图例', key: 'value3' },
        { name: "单位", key: "value4" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
    }
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
    defaultdata(n) {
      this.DrawEcharts()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    ...methods,
    customRound(number) {
      return Math.round(number / 10) * 10;
    },
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
      let unit = this.defaultdata[0].value4 || ''
      let mydata = this.defaultdata.map((item) => {
        return {
          name: item.value1,
          value: item.value2,
        };
      });
      let yAxis = mydata.map((item) => item.name);
      const percent = (5 / yAxis.length) * 100;
      const zoom = [
        {
          id: "scope48", // 唯一的id
          filterMode: "empty",
          yAxisIndex: [0], //滑动条为竖
          mayValueSpan: 5, // 显示数据的条数(默认显示10个)
          type: "slider",
          showDetail: false, //关闭：拖拽时候显示详细数值信息。
          dataBackground: {
            show: false,
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          selectedDataBackground: {
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          backgroundColor: "transparent",
          fillerColor: "transparent",
          borderColor: "transparent",
          start: 0,
          end: percent,
          right: 0,
          zlevel: 3, //重点，层级必须设置大于柱状图
        },
      ];
      var Toption = {
        title: [
          {
            text: unit,
            top: "0",
            right: "0",
            textStyle: {
              color: "#979AA0",
              fontSize: 12,
              width: 80,
              overflow: 'truncate'
            },
          },
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: [
          {
            top: "2%",
            right: "40%",
            itemHeight: 12, //图例的高度  文字左边那个
            itemWidth: 10,
            icon: "rect",
            textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
            data: [this.defaultdata[0].value3 || ""],
          },
        ],
        grid: {
          left: "5px",
          right: "10px",
          bottom: "10px",
          top: "20px",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
            },
          },
        },
        yAxis: {
          type: "category",
          zlevel: 10,
          z: 10,
          // max: 5,
          // data: mydata.map(item => item.name),
          data: yAxis,
          axisLabel: {
            interval: 0,
            width: 54,
            overflow: "truncate", //文字超出宽度截断，默认为...
            // overflow: 'break', //文字超出宽度截断 换行
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
            // formatter: function (value) {
            // 		return value.length > 6 ? value.slice(0, 5) + '...' : value;
            // }
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
              // width: 1,
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: this.defaultdata[0].value3 || "",
            type: "bar",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "#00c6f0" },
                { offset: 0.5, color: "#00a4fc" },
                { offset: 1, color: "#0084fe" },
              ]),
            },
            showBackground: true, //控制是否显示背景色
            backgroundStyle: {
              color: '#141412'
            },
            barWidth: 15,
            barGap: "40%",
            data: mydata,
          },
          {
            type: "pictorialBar", //设置类型为象形柱状图
            barWidth: "15%", // 设置柱宽为容器宽度的20%
            symbol: "rect", // 使用矩形作为柱子的形状
            symbolMargin: 2, // 设置符号之间的间距
            symbolRepeat: true, // 重复符号以填充柱子
            symbolSize: ["50%", 15], // 设置符号的大小
            tooltip: {
              show: false,
            },
            // 分隔
            itemStyle: {
              normal: {
                color: "#141412",
              },
            },
            data: mydata,
            z: 1,
            zlevel: 2, //重点，层级必须设置大于柱状图
          },
        ],
      };
      if (yAxis && yAxis.length > 5) {
        Toption.dataZoom = zoom;
      }
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {

  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.DrawEcharts(); //需要刷新的数据
  },
}
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>
